import React from 'react';
import { Phone, Mail, MapPin, Calendar, Building } from 'lucide-react';

const EtablissementMainInfo = ({ etablissement }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Non spécifiée';
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-gray-100 mb-8 overflow-hidden">
      {/* Header avec logo et nom */}
      <div className="bg-gradient-to-r from-[#202654] to-[#2a2f6a] px-8 py-8">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Logo */}
          <div className="flex-shrink-0 mb-6 lg:mb-0 lg:mr-8">
            <div className="w-24 h-24 bg-white/20 rounded-2xl flex items-center justify-center shadow-lg backdrop-blur-sm">
              {etablissement.logo_url ? (
                <img
                  src={etablissement.logo_url}
                  alt="Logo de l'établissement"
                  className="w-16 h-16 object-contain rounded-xl"
                />
              ) : (
                <Building className="h-12 w-12 text-white" />
              )}
            </div>
          </div>
          
          {/* Nom et devise */}
          <div className="text-center lg:text-left">
            <h2 className="text-2xl lg:text-3xl font-bold text-white mb-3 leading-tight">
              {etablissement.libelle}
            </h2>
            <p className="text-lg text-blue-100 font-medium italic">
              "{etablissement.devise}"
            </p>
          </div>
        </div>
      </div>

      {/* Informations de contact */}
      <div className="p-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Contact et Email */}
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-gray-50 to-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-start">
                <div className="bg-gradient-to-br from-[#202654] to-[#2a2f6a] p-3 rounded-lg mr-4 flex-shrink-0">
                  <Phone className="h-5 w-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Contact
                  </h3>
                  <p className="text-lg font-bold text-gray-900 break-all">
                    {etablissement.contact}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-gray-50 to-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-start">
                <div className="bg-gradient-to-br from-[#202654] to-[#2a2f6a] p-3 rounded-lg mr-4 flex-shrink-0">
                  <Mail className="h-5 w-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Email
                  </h3>
                  <p className="text-lg font-bold text-gray-900 break-all">
                    {etablissement.email}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Adresse et Date */}
          <div className="space-y-6">
            <div className="bg-gradient-to-r from-gray-50 to-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-start">
                <div className="bg-gradient-to-br from-[#202654] to-[#2a2f6a] p-3 rounded-lg mr-4 flex-shrink-0">
                  <MapPin className="h-5 w-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Adresse
                  </h3>
                  <p className="text-lg font-bold text-gray-900 break-words">
                    {etablissement.adresse}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-gray-50 to-white rounded-xl p-6 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="flex items-start">
                <div className="bg-gradient-to-br from-[#202654] to-[#2a2f6a] p-3 rounded-lg mr-4 flex-shrink-0">
                  <Calendar className="h-5 w-5 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
                    Date de création
                  </h3>
                  <p className="text-lg font-bold text-gray-900">
                    {formatDate(etablissement.date_creation)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EtablissementMainInfo; 